import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getLastResults, getDetailResults } from '../../../../apiservices/CasionApi';
import RefResultModal from '../../../casinoComponents/refResultModal';
import GoalResultBody from '../../../casinoComponents/refResultModal/GoalResultBody';
import { formatRefMatchTime } from '../../../../utils/refMatchTime';

/**
 * Goal "Last Result" items in the reference markup (inside .casino-video-last-results):
 *   every round → <span class="resultb">R</span>
 * Click → .loader-overlay (in .page-content) while the round detail loads, then the reference result modal.
 * Last results are refetched when the round changes (reference: getLastResults on a new mid).
 */
const ResultGoals = ({ data = [], gameData = {}, roundId, onTitle, gameType = 'goal' }) => {
    const [lastResults, setLastResults] = useState([]);
    const [detailResult, setDetailResult] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const currentMid = roundId ?? gameData?.data?.data?.mid ?? gameData?.mid;
    const hasData = Array.isArray(data) && data.length > 0;

    useEffect(() => {
        if (hasData) return;
        let cancelled = false;
        const fetchLastResults = async () => {
            try {
                const response = await getLastResults(gameType);
                const res = response?.data?.data?.res;
                if (!cancelled && Array.isArray(res)) setLastResults(res);
                const cname = response?.data?.data?.res1?.cname;
                if (!cancelled && cname) onTitle?.(cname);
            } catch (error) {
                console.error('Error fetching last results:', error);
            }
        };
        fetchLastResults();
        return () => { cancelled = true; };
    }, [hasData, currentMid, onTitle, gameType]);

    const results = hasData ? data : lastResults;

    const handleResultClick = async (mid) => {
        if (!mid) return;
        setLoading(true);
        try {
            const response = await getDetailResults(gameType, mid.toString());
            const t1 = response?.data?.data?.t1 ?? response?.data?.t1;
            setDetailResult(t1 || null);
            setShowModal(!!t1);
        } catch (error) {
            console.error('Error fetching detail results:', error);
        }
        setLoading(false);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setDetailResult(null);
    };

    return (
        <>
            {results.map((r, index) => (
                <span key={r?.mid ?? index} className="resultb" onClick={() => handleResultClick(r?.mid)}>
                    R
                </span>
            ))}
            {loading && createPortal(<div className="loader-overlay" />, document.querySelector('.page-content') || document.body)}
            <RefResultModal
                show={showModal && !loading && !!detailResult}
                onHide={handleCloseModal}
                title={`${detailResult?.ename || 'Goal'} Result`}
                roundId={detailResult?.rid}
                matchTime={formatRefMatchTime(detailResult?.mtime)}
            >
                <GoalResultBody t1={detailResult} />
            </RefResultModal>
        </>
    );
};

export default ResultGoals;
